import React from 'react';

export const Mail = ({ width = 24, height = 24 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.33398 3.99495C2.96579 3.99495 2.66732 4.29343 2.66732 4.66162V11.3283C2.66732 11.6965 2.96579 11.995 3.33398 11.995H12.6673C13.0355 11.995 13.334 11.6965 13.334 11.3283V4.66162C13.334 4.29343 13.0355 3.99495 12.6673 3.99495H3.33398ZM1.33398 4.66162C1.33398 3.55705 2.22941 2.66162 3.33398 2.66162H12.6673C13.7719 2.66162 14.6673 3.55705 14.6673 4.66162V11.3283C14.6673 12.4329 13.7719 13.3283 12.6673 13.3283H3.33398C2.22941 13.3283 1.33398 12.4329 1.33398 11.3283V4.66162Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.44602 4.30182C1.65026 3.99547 2.06417 3.91269 2.37052 4.11692L8.00072 7.87039L13.6309 4.11692C13.9373 3.91269 14.3512 3.99547 14.5554 4.30182C14.7597 4.60817 14.6769 5.02209 14.3705 5.22632L8.37052 9.22632C8.14659 9.37561 7.85485 9.37561 7.63092 9.22632L1.63092 5.22632C1.32457 5.02209 1.24179 4.60817 1.44602 4.30182Z"
      fill="currentColor"
    />
  </svg>
);
